module.exports = __webpack_public_path__ + "img/pay-pal-icon.a5ceaff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/pay-pal-icon.png
// module id = u0ct
// module chunks = 1